module.exports = __webpack_public_path__ + "img/app_download_new.70fd9d1d.jpg";